import { Link } from "react-router-dom";
import { useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";
import React, { useState } from "react";

import ContainedButton from "../../components/Buttons/ContainedButton";

const ContactUsForm = () => {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <div
      className="col-10"
      style={{
        maxWidth: 850,
        background: "white",
        borderRadius: 35,
        height: 700,
        marginTop: "-60px",
        marginRight: "50px",
        boxShadow: "0px 3px 6px #00000029",
        position: "relative",
        zIndex: 1000,
      }}
    >
      <div
        style={{
          width: "50%",
          color: theme.COLORS.BLUE.darkBlueGreen,
          fontSize: "2rem",
          marginTop: "10px",
          height: "50px",
          margin: "0 auto",
          padding: "15px",
          position: "relative",
          textAlign: "center",
        }}
      >
        {t("Need Help?")}
      </div>
      <div
        style={{
          width: "100%",
          color: theme.COLORS.BLUE.darkBlueGreen,
          fontSize: "2rem",
          height: "auto",
          margin: "0 auto",
          padding: "15px",
          position: "relative",
          textAlign: "center",
        }}
      >
        {t("Send Us A Message!")}
      </div>

      <div
        style={{
          height: "auto",
          margin: "0 auto",
          paddingLeft: "55px",
          paddingRight: "55px",
          position: "relative",
          marginTop: "4vh",
        }}
      >
        <p
          style={{
            color: "#2c495d",
            marginBottom: "0px",
            fontWeight: "bold",
            paddingBottom: "2px",
          }}
        >
          {t("Full Name")}
        </p>
        <input
          style={{
            borderColor: "white",
            backgroundColor: "#e6f6fd",
            borderRadius: 10,
            width: "100%",
            height: 45,
            fontWeight: "bold",
          }}
          value={fullName}
          onChange={e => setFullName(e.target.value)}
        ></input>
        <div className="row" style={{ marginTop: "3vh" }}>
          <div className="col-6">
            <p
              style={{
                color: "#2c495d",
                marginBottom: "0px",
                fontWeight: "bold",
                paddingBottom: "2px",
              }}
            >
              {t("Email Address")}
            </p>
            <input
              style={{
                borderColor: "white",
                backgroundColor: "#e6f6fd",
                borderRadius: 10,
                width: "100%",
                height: 45,
                fontWeight: "bold",
              }}
              value={email}
              onChange={e => setEmail(e.target.value)}
            ></input>
          </div>
          <div className="col-6">
            <p
              style={{
                color: "#2c495d",
                marginBottom: "0px",
                fontWeight: "bold",
                paddingBottom: "2px",
              }}
            >
              {t("Phone Number")}
            </p>
            <input
              style={{
                borderColor: "white",
                backgroundColor: "#e6f6fd",
                borderRadius: 10,
                width: "100%",
                height: 45,
                fontWeight: "bold",
              }}
              value={phoneNumber}
              onChange={e => setPhoneNumber(e.target.value)}
            ></input>
          </div>
        </div>
        <p
          style={{
            color: "#2c495d",
            marginBottom: "0px",
            marginTop: "3vh",
            fontWeight: "bold",
            paddingBottom: "2px",
          }}
        >
          {t("Subject")}
        </p>
        <input
          style={{
            borderColor: "white",
            backgroundColor: "#e6f6fd",
            borderRadius: 10,
            width: "100%",
            height: 45,
            fontWeight: "bold",
          }}
          value={subject}
          onChange={e => setSubject(e.target.value)}
        ></input>
        <p
          style={{
            color: "#2c495d",
            marginBottom: "0px",
            marginTop: "3vh",
            fontWeight: "bold",
            paddingBottom: "2px",
          }}
        >
          {t("Message")}
        </p>
        <textarea
          style={{
            borderColor: "white",
            backgroundColor: "#e6f6fd",
            borderRadius: 10,
            width: "100%",
            height: 110,
            fontWeight: "bold",
          }}
          value={message}
          onChange={e => setMessage(e.target.value)}
        ></textarea>
      </div>
      <div
        className="row"
        style={{
          marginTop: "2vh",
          marginLeft: "62vh",
        }}
      >
        <Link
          to={""}
          style={{
            color: theme.COLORS.WHITE.backgroundWhite,
            textDecoration: "none",
            width: "auto",
          }}
        >
          <ContainedButton
            className="col-auto"
            styles={{ width: "140px", marginLeft: "-210px" }}
          >
            {t("SUBMIT")}
          </ContainedButton>
        </Link>
      </div>
      <div
        style={{
          borderRadius: "0px 50px 0px 50px",
          width: 50,
          height: 140,
          borderWidth: "3px",
          borderStyle: "solid",
          borderColor: theme.COLORS.GREEN.green,
          backgroundColor: theme.COLORS.GREEN.green,
          marginLeft: "-3vh",
          marginTop: "-105px",
        }}
      />
    </div>
  );
};

export default ContactUsForm;
